import { useSessionContext } from "src/hooks"
import { AppCompaniesChoices, MidGameCompanies, MidGameConfiguration } from "src/types"
import { midGameConfiguration } from "src/pages/MidGame/utils"

export const useGetMidGameConfiguration = (): {
    configuration: MidGameConfiguration | null,
    type: MidGameCompanies
} => {
    const { currentRound, rounds } = useSessionContext()

    const currentCompany = rounds[currentRound - 1]

    if (currentRound === 5) {
        return {
            configuration: midGameConfiguration.final,
            type: "final"
        }
    }
    if (
        [
            AppCompaniesChoices["vtb"],
            AppCompaniesChoices["robo-finance"],
            AppCompaniesChoices["sport-master"]
        ]
            .includes(currentCompany as AppCompaniesChoices)
    ) {
        return {
            configuration: midGameConfiguration[currentCompany as string],
            type: currentCompany
        }
    } else if (currentCompany === AppCompaniesChoices.h) {
        return {
            configuration: midGameConfiguration[AppCompaniesChoices.h],
            type: AppCompaniesChoices.h
        }
    } else {
        return {
            configuration: midGameConfiguration.misc,
            type: null
        }
    }
}
